import {ModalityEnum} from 'domain/usecases/private/refund/request-preview';
import {z} from 'zod';

export const FormSchema = z.object({
	beneficiary: z.object({
		userCode: z.string(),
		fullName: z.string(),
		fullSocialName: z.string().nullable(),
		beneficiaryType: z.string(),
	}),
	description: z.string().trim().min(10),
	modality: z.nativeEnum(ModalityEnum),
});

export type FormSchemaValues = z.infer<typeof FormSchema>;
